import { GlAvatar, GlIcon, GlLink, GlPopover, GlSkeletonLoader, GlTruncate } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__, sprintf } from '~/locale';
import { getTimeago } from '~/lib/utils/datetime_utility';
import { newDate } from '~/lib/utils/datetime/date_calculation_utility';
import defaultAvatarUrl from 'images/no_avatar.png';
import query from '../queries/commit.query.graphql';
export default {
    name: 'CommitPopover',
    i18n: {
        errorMessage: s__('CommitPopover|Could not load commit. Please reload the page.')
    },
    components: {
        GlAvatar,
        GlIcon,
        GlLink,
        GlPopover,
        GlSkeletonLoader,
        GlTruncate
    },
    props: {
        target: {
            type: HTMLAnchorElement,
            required: true
        },
        projectPath: {
            type: String,
            required: true
        },
        commitSha: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            commit: {},
            hasError: false
        };
    },
    apollo: {
        commit: {
            query,
            variables () {
                return {
                    projectPath: this.projectPath,
                    sha: this.commitSha
                };
            },
            update: (data)=>data.project?.repository?.commit ?? {},
            error () {
                this.hasError = true;
            }
        }
    },
    computed: {
        authorName () {
            return this.commit.author?.name ?? this.commit.authorName ?? '';
        },
        avatarUrl () {
            return this.commit.author?.avatarUrl ?? defaultAvatarUrl;
        },
        authoredText () {
            if (!this.commit.authoredDate) return '';
            const timeago = getTimeago().format(newDate(this.commit.authoredDate));
            return sprintf(__('Authored %{timeago}'), {
                timeago
            });
        },
        isLoading () {
            return this.$apollo.queries.commit.loading;
        }
    }
};
